/** Shared formatting for the Reports module. All money here is USD. */

export const money = (n) => `$${(Number(n) || 0).toLocaleString('en-US', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
})}`;

export const monthName = (m) => new Date(2000, Number(m) - 1, 1).toLocaleString('en-US', { month: 'long' });

export const periodLabel = (month, year) => `${monthName(month)} ${year}`;

export const shortDate = (v) => (v
  ? new Date(v).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
  : '-');

export const percent = (part, whole) => (whole ? `${((part / whole) * 100).toFixed(1)}%` : '-');
